(function (ws) {
    'use strict';

    ws.views.tabs = Backbone.View.extend({

        events: {
            'click .tabs-menu li': 'tabClick'
        },

        enableScroll: true,

        /**
         * Initialize
         */
        initialize: function () {
            this.eventAgg.on('reInitializeTab', this.reInitializeTab, this);
            this.$content = this.$('.content');
            this.$tabMenu = this.$('.tabs-menu');
            this.$tabsContent = this.$('.tab-content');
            this.$tabs = this.$('.tabs-menu li');

            this.selectTab(this.$tabs.filter('[data-default]').data('tab'));

            if (this.$el.data('name')) {
                this.eventAgg.on('tab-' + this.$el.data('name'), this.selectTab.bind(this));
            }
        },

        /**
         * Tab Click
         */
        tabClick: function (e) {
            this.selectTab($(e.currentTarget).data('tab'), this.enableScroll);
        },

        /**
         * Select Tab
         * @param {string} tabName
         */
        selectTab: function (tabName, scroll) {
            this.$tabsContent.hide();
            this.$tabs.removeClass('selected');
            this.$tabMenu.find('[data-tab="' + tabName + '"]').addClass('selected');
            this.$content.find('[data-tab="' + tabName + '"]').show();

            if (scroll) {
                this.scrollTo();
            }

            setTimeout(function () {
                this.eventAgg.trigger('tab-' + tabName, true);
            }.bind(this), 0);
        },

        /**
         * Scroll to this Tabs
         */
        scrollTo: function () {
            $('html, body').animate({
                scrollTop: this.$el.position().top
            }, 500);
        },

        reInitializeTab: function() {
            this.$content = this.$('.content');
            this.$tabMenu = this.$('.tabs-menu');
            this.$tabsContent = this.$('.tab-content');
            this.$tabs = this.$('.tabs-menu li');

            this.selectTab(this.$tabs.filter('[data-default]').data('tab'));

            if (this.$el.data('name')) {
                this.eventAgg.on('tab-' + this.$el.data('name'), this.selectTab.bind(this));
            }
        }
    });

})(westcon);
